const mapStateToProps = (state) => {
    const {
        ui: {
            burgerMenuOpened
        } = {},
    } = state;
    return {
        burgerMenuOpened
    }
}

export default mapStateToProps;